import OnexOne from "@/widgets/Nota/Templates/OnexOne";
import OnexTwo from "@/widgets/Nota/Templates/OnexTwo";
import Half from "@/widgets/Nota/Templates/Half";
import TwoxOneNoImage from "@/widgets/Nota/Templates/TwoxOneNoImage";
import TwoxOneVisual from "@/widgets/Nota/Templates/TwoxOneVisual";

const NOTE_TEMPLATES = {
  OnexOne,
  OnexTwo,
  Half,
  TwoxOneNoImage,
  TwoxOneVisual
};

export const getEnabledCrossContent = (modules) => {
  let find = false;
  if (!Array.isArray(modules)) return find;
  for (let index = 0; index < modules.length; index++) {
    const arrayModules = modules[index].innerBoxes[0].subItems;
    arrayModules.forEach((module) => {
      if (
        module.template == "Container2PisosBanner" &&
        module.params?.crossContentEnabled
      )
        find = true;
    });
  }
  return find;
};

export const getEnabledElleMagazines = (modules) => {
  let find = false;
  if (!Array.isArray(modules)) return find;
  for (let index = 0; index < modules.length; index++) {
    const arrayModules = modules[index].innerBoxes[0].subItems;
    arrayModules.forEach((module) => {
      if (
        module.template == "RevistaElle"
      )
        find = true;
    });
  }
  return find;
};

export const getEnabledMostRead = (modules) => {
  let find = false;
  if (!Array.isArray(modules)) return find;
  for (let index = 0; index < modules.length; index++) {
    const arrayModules = modules[index].innerBoxes[0].subItems;
    arrayModules.forEach((module) => {
      if (
        module.template == "MostViewed"
      )
        find = true;
    });
  }
  return find;
};

export const getAgendaEnabled = (modules) => {
  let find = false;
  if (!Array.isArray(modules)) return find;
  for (let index = 0; index < modules.length; index++) {
    const arrayModules = modules[index].innerBoxes[0].subItems;
    arrayModules.forEach((module) => {
      if (
        module.template == "Container3PisosC"
        || module.template == "Container3PisosD"
      )
        find = true;
    });
  }
  return find;
};

export const getEnabledMostReadBySection = (modules) => {
  let find = false;
  if (!Array.isArray(modules)) return find;
  for (let index = 0; index < modules.length; index++) {
    const arrayModules = modules[index].innerBoxes[0].subItems;
    arrayModules.forEach((module) => {
      if (
        module.template == "ContainerList"
      )
        find = true;
    });
  }
  return find;
};

export const getEnabledWidget = (modules, template) => {
  let find = false;
  if (!Array.isArray(modules)) return find;
  for (let index = 0; index < modules.length; index++) {
    const arrayModules = modules[index].innerBoxes[0].subItems;
    arrayModules.forEach((module) => {
      if (
        module.template == template
      )
        find = true;
    });
  }
  return find;
};

export const renderContainerWidgetCallback = (index, templateName, extra = {}, content, isListType = true) => {
  const news = content?.[index - 1];
  if (!news) return null;

  const Template = NOTE_TEMPLATES[templateName] || OnexOne;
  return (
    <Template
      {...news}
      __extra={{
        isListType: isListType,
        containerName: extra.containerName || "contenedor_fama",
      }}
    />
  );
};